<template>
  <div class='bookpage'>
    <topNav :title="title"
            :noMore='true'></topNav>

    <bookTab @showPage='showPage'
             :page-index='pageIndex'></bookTab>

    <div class="bcont">
      <div class="form">
        <div class='basic-user-info'>
          <div class="info"
               v-show="pageIndex==5">
            <!-- 旅行社 -->
            <label>{{ $t('book_name5') }}</label>
            <popSearch ref='inputa'
                       type="A"
                       anchor='name'
                       @onSelect='onSelect'></popSearch>
          </div>
          <div class="info"
               v-show="pageIndex==4">
            <!-- 订房中心 -->
            <label>{{ $t('book_name4') }}</label>
            <popSearch ref='inputs'
                       type="S"
                       anchor='name'
                       @onSelect='onSelect'></popSearch>
          </div>
          <div class="info"
               v-show="pageIndex==3">
            <!-- 协议公司 -->
            <label> {{ $t('book_name3') }}</label>
            <popSearch ref='inputc'
                       type="C"
                       anchor='name'
                       @onSelect='onSelect'></popSearch>
          </div>
          <div class="info"
               v-show="pageIndex==2">
            <!-- 会员卡 -->
            <label>{{ $t('book_name2') }}</label>
            <popSearch ref="inputmem"
                       type="mem"
                       anchor='cardNo'
                       :searchNow="false"
                       @onSelect='onSelect'></popSearch>
          </div>
          <div class="info"
               style="position:relative">
            <!-- 姓名 请填写预订人姓名（必填）-->
            <label>{{ $t('book_rsvMan') }} <i class="must">*</i></label>
            <input class="inp"
                   type="text"
                   :readonly="bookInfo.address"
                   :placeholder="$t('book_rsvMan_placeholder') "
                   maxlength="64"
                   v-model='bookInfo.rsvMan'>
            <!--            TODO 锦江用身份证刷卡-->
            <i class="iconfont icon-saoma"
               @click="sfzRe"
               style="position: absolute;right:0.42rem;color:#999"
               v-if="sfzR && !isJingJiang"></i>
            <i class="iconfont icon-credentials_icon"
               @click="getJingJiangToken"
               style="position: absolute;right: 0.42rem;color:#999"
               v-if="isJingJiang"></i>
          </div>
          <div class="info">
            <!-- 手机 请填写11位手机号码（可空）-->
            <label>{{ $t('book_mobile') }}</label>
            <input class="inp"
                   type="number"
                   :placeholder="$t('book_mobile_placeholder') "
                   maxlength="11"
                   v-model='bookInfo.mobile'>
          </div>

          <template v-show="!(isJingJiang && isReserve)">
            <div class="info">
              <!-- 证件类型 请填写11位手机号码（可空）-->
              <label>{{ $t('book_idCode') }} </label>
              <div class="parent">
                <gpicker ref="idCode"></gpicker>
              </div>
            </div>
            <div class="info">
              <!-- 证件号码 请填写证件号码(可空)-->
              <label>{{ $t('book_idNo') }}</label>
              <input type="text"
                     class="inp"
                     :readonly="bookInfo.address"
                     :placeholder="$t('book_idNo_placeholder')"
                     v-model='bookInfo.idNo'>
            </div>
          </template>
        </div>

        <div class='multiple-room-wrap'
             :class='{isNormal: isNormal}'>
          <div class='multiple-container'
               :class='{isNormal: isNormal}'>
            <div class='multiple-room-edit'
                 :class='{isNormal: isNormal}'>
              <div class="info">
                <!-- 入住/离店-->
                <label>{{ $t('book_range') }} <i class="must">*</i></label>
                <div class="parent">
                  <datepicker v-model="range"
                              @input="dateChange"
                              ref='rangePicker'
                              class="picker picker-range"
                              :min="start"
                              :max="end"
                              v-if='showRoomItem'
                              :hideClear='true'
                              :range="true"></datepicker>
                </div>
              </div>

              <div v-if='isBook'>
                <div class="info">
                  <!-- 房间数-->
                  <label>{{ $t('book_rmnum') }}<i class="must">*</i></label>

                  <div class='input-numer-wrap'>
                    <input-number ref="rmnum"
                                  @input="rmnumChange"
                                  v-model='bookingRsvSrcDto[currentIndex].rmnum'
                                  :value='bookingRsvSrcDto[currentIndex].rmnum'
                                  :max='999'
                                  v-if='showRoomItem'
                                  :min='1'></input-number>
                  </div>
                </div>
                <div class="info">
                  <!-- 房型-->
                  <label>{{ $t('book_rmtype') }}<i class="must">*</i></label>
                  <div class="parent">
                    <gpicker ref="rmtype"
                             @change="changeRmType"></gpicker>
                  </div>
                </div>
              </div>

              <div v-else>
                <template v-if='isMultipleBook'>
                  <div class="info">
                    <!-- 房间号-->
                    <label>{{ $t('book_rmno') }}<i class="must">*</i></label>
                    <div class="parent">
                      <input type="text"
                             class="inp"
                             v-if='bookingRsvSrcDto[currentIndex] && bookingRsvSrcDto[currentIndex].rmno'
                             v-model='bookingRsvSrcDto[currentIndex].rmno'
                             style="color:#F69C2D"
                             readonly="readonly">
                    </div>
                  </div>

                  <div class="info">
                    <!-- 房型-->
                    <label>{{ $t('book_rmtype') }}<i class="must">*</i></label>
                    <div class="parent">
                      <input type="text"
                             class="inp"
                             v-if='bookingRsvSrcDto[currentIndex] && bookingRsvSrcDto[currentIndex].rmtype'
                             v-model='bookingRsvSrcDto[currentIndex].rmtype'
                             style="color:#F69C2D"
                             readonly="readonly">
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="info">
                    <!-- 房间号-->
                    <label>{{ $t('book_rmno') }}<i class="must">*</i></label>
                    <div class="parent">
                      <input type="text"
                             class="inp"
                             v-model='bookInfo.rmno'
                             style="color:#F69C2D"
                             readonly="readonly">
                    </div>
                  </div>

                  <div class="info">
                    <!-- 房型-->
                    <label>{{ $t('book_rmtype') }}<i class="must">*</i></label>
                    <div class="parent">
                      <input type="text"
                             class="inp"
                             v-model='bookingRsvSrcDto[currentIndex].rmtype'
                             style="color:#F69C2D"
                             readonly="readonly">
                    </div>
                  </div>
                </template>
              </div>

              <!--              以后就隐藏掉不用了-->
              <div class="info"
                   style='width: 100%; height: 0; margin: 0'>
                <!-- 房价码-->
                <label>
                  {{ $t('book_ratecode') }}<i class="must">*</i>
                </label>
                <div class="parent"
                     :class='{"spe-parent-rate" : rateChange}'>
                  <gpicker ref="ratecode"
                           @change="changeRateCode"></gpicker>
                </div>
                <template v-if="isReserve && !isMultipleBookIn">
                  <div class='self-define-btn'
                       v-if='rateChange'
                       @click='openEditPriceModal()'>
                    <i class='mintui mintui-more'></i>
                  </div>
                </template>
              </div>

              <div class="info"
                   style='width: 100%;'>
                <!-- 新版房价码-->
                <label>
                  {{ $t('book_ratecode') }}<i class="must">*</i>
                </label>
                <div class="parent"
                     @click="openChangeRateModal"
                     :class='{"spe-parent-rate" : rateChange}'>
                  <div class="rate-text">{{ getCurrentRateText() }}</div>
                  <span class="iconfont icon-xia"></span>
                </div>
                <template v-if="isReserve && !isMultipleBookIn">
                  <div class='self-define-btn'
                       v-if='rateChange'
                       @click='openEditPriceModal()'>
                    <i class='mintui mintui-more'></i>
                  </div>
                </template>
              </div>

              <!-- 首日房价-->
              <p class="tip">{{ $t('book_firstDayMoney') }}:
                {{ bookingRsvSrcDto[currentIndex] && bookingRsvSrcDto[currentIndex].firstDayMoney }}
              </p>
              <div class="info">
                <!-- 包价-->
                <label>{{ $t('book_pkage') }}</label>
                <div class="parent">
                  <!-- 可空-->
                  <multiSelect ref="pkage"
                               :showCode1="true"
                               @finish='changePackages'
                               :placeholder="$t('placeHolder_Empty') "></multiSelect>
                </div>
              </div>
            </div>

            <div class='action-nav'
                 v-if='!isNormal'>
              <span class='action-nav-item'
                    :class='{active : currentIndex == index}'
                    @click='selectRoomIndex(item,index)'
                    v-for='(item,index) in bookingRsvSrcDto'>
                {{ index + 1 }}
              </span>
            </div>
          </div>
          <div class='btn-wrap'
               v-if='isBook && moreRoom'>
            <div class='btn-add-item'
                 @click='addRoomItem'>
              {{ this.$t('book_addRmType_btn') }}<i class="iconfont icon-jia"></i>
            </div>
            <div class='btn-add-item btn-remove'
                 v-if='showDeleteBtn'
                 @click='removeRoomItem'>
              {{ this.$t('book_removeRmType_btn') }}<i class="iconfont icon-jian1"
                                                       style='font-weight: bold;'></i>
            </div>
          </div>

          <div class='btn-wrap'
               v-if='isMultipleBook'>
            <div class='btn-add-item '
                 v-if='showDeleteBtn2'
                 @click='removeRoomItem'>
              {{ this.$t('book_removeRmType_btn') }}<i class="iconfont icon-jian1"
                                                       style='font-weight: bold;'></i>
            </div>
          </div>
        </div>

        <div class='more-info-wrap'>
          <div class="more"
               @click="more=!more">
            <!-- 更多参数-->
            <div class="mdiv"
                 v-if="!more">{{ $t('book_more_parmas') }}{{$bookNew ? '.' : ''}}  <i class="iconfont icon-xiaa"></i></div>
            <!-- 收起参数-->
            <div class="mdiv"
                 v-else>{{ $t('book_packup_parmas') }}<i class="iconfont icon-shanga"></i></div>
          </div>

          <div class='more-info-list'
               v-show="more">
            <div class="info">
              <!-- 房价保密-->
              <label>{{ $t('book_rateSecret') }}</label>
              <div class="parent"
                   style="border:0;padding-left: 50%;">
                <mt-switch v-model="rateSecret"></mt-switch>
              </div>
            </div>
            <div class="info">
              <!-- 预订类型-->
              <label>{{ $t('book_rsvType') }}<i class="must">*</i></label>
              <div class="parent">
                <gpicker ref="rsvType"></gpicker>
              </div>
            </div>

            <div class="info">
              <!-- 市场-->
              <label>{{ $t('book_market') }}<i class="must">*</i></label>
              <div class="parent">
                <gpicker ref="market"></gpicker>
              </div>
            </div>
            <div class="info">
              <!-- 来源-->
              <label>{{ $t('book_src') }} <i class="must">*</i></label>
              <div class="parent">
                <gpicker ref="src"></gpicker>
              </div>
            </div>
            <div class="info">
              <!-- 渠道-->
              <label>{{ $t('book_channel') }}<i class="must">*</i></label>
              <div class="parent">
                <gpicker ref="channel"></gpicker>
              </div>
            </div>
            <div class="info">
              <!-- 佣金码-->
              <label>{{ $t('book_cms_code') }}</label>
              <div class="parent">
                <gpicker ref="cms_code"
                         :canEmpty="true"
                         :placeholder="$t('placeHolder_Empty')"></gpicker>
              </div>
            </div>
            <div class="info">
              <!-- 付款码-->
              <label>{{ $t('book_payCode') }}<i class="must">*</i></label>
              <div class="parent">
                <gpicker ref="payCode"
                         :placeholder="$t('placeHolder_Empty')"></gpicker>
              </div>
            </div>
            <div class="info">
              <!-- 销售员-->
              <label>{{ $t('book_salesman') }} </label>
              <div class="parent" @click="openSaleSelect">
                <div>
                  <span v-if="choosedSaleManCode">
                    {{ choosedSaleMan.code }} -- {{ choosedSaleMan.name }}
                  </span>
                  <span style="color: #ccc" v-else>选择销售员</span>
                </div>
                <span class="iconfont icon-xia"></span>
                <!--                <gpicker ref="salesman"-->
                <!--                         :canEmpty="true"-->
                <!--                         :placeholder="$t('placeHolder_Empty')"></gpicker>-->
              </div>
            </div>
            <div class="info">
              <label>{{ $t('book_amenities') }} </label>
              <input type="text"
                     class="inp"
                     :placeholder="$t('placeHolder_Empty')"
                     v-model='bookInfo.amenities'>
            </div>
            <div class="info">
              <label>{{ $t('book_specials') }} </label>
              <input type="text"
                     class="inp"
                     :placeholder="$t('placeHolder_Empty')"
                     v-model='bookInfo.specials'>
            </div>
            <div class="info">
              <label>{{ $t('book_creditMan') }} </label>
              <input type="text"
                     class="inp"
                     :placeholder="$t('placeHolder_Empty')"
                     v-model='bookInfo.creditMan'>
            </div>
            <div class="info"
                 v-if="isBook">
              <label>{{ $t('book_otaRsvNo') }} </label>
              <input type="text"
                     class="inp"
                     :placeholder="$t('placeHolder_Empty')"
                     v-model='bookInfo.otaRsvNo'>
            </div>
          </div>
        </div>

        <div class="info">
          <label>{{ $t('book_coMsg') }}</label>
          <textarea class="remark"
                    v-model="bookInfo.coMsg"
                    :placeholder="$t('placeHolder_Empty')"></textarea>
        </div>
        <div class="info">
          <!-- 备注-->
          <label>{{ $t('book_remark') }}</label>
          <textarea class="remark"
                    v-model="bookInfo.remark"
                    :placeholder="$t('placeHolder_Empty')"></textarea>
        </div>
      </div>
    </div>

    <bookFooter :book-info='bookInfo'
                ref='bookFooter'
                :title='title'
                :bookingRsvSrcDto='bookingRsvSrcDto'
                @book='book'></bookFooter>

    <div class='edit-price-modal'
         v-if='showEditPriceModal'>
      <div class='edit-price-modal-container'>
        <div class='edit-price-title'>
          {{ $t('book_define_title') }}（{{ currentItem.roomName }}）

          <i class='iconfont icon-cuowu'
             @click='closeEditPrice'></i>
        </div>
        <div class='edit-top-nav'>
          <span class='edit-top-item edit-date'>{{ $t('fangTXQ_date') }}</span>
          <span class='edit-top-item origin-price'>{{ $t('book_origin_price') }}</span>
          <span class='edit-top-item edit-price'>{{ $t('fangTXQ_rate') }}</span>
          <span class='edit-top-item edit-reason'>{{ $t('book_reason') }}</span>
        </div>
        <div class='edit-price-body'>
          <div class='edit-price-item'
               :class='{active: currentLi == index}'
               @click='setCurrentLi(index)'
               v-for='(item, index) in currentRsvRates'
               :key='"everyDayRate" + item.d'>
            <span class='edit-date'
                  :class='{firday:new Date(item.d).getDay()== 6 || new Date(item.d).getDay()== 0}'
                  style='text-align: center;'>
              {{ item.d | dateMD }}
              <br>
              {{ item.d | week }}
            </span>
            <span class='origin-price'
                  style='text-align: center;'>{{ item.privce }} {{ item.disc1 }}</span>
            <!-- 房费-->
            <div class='edit-price'>
              <span>￥
                <input type='number'
                       :disabled='!item.dscResaon'
                       class='spe-input'
                       v-model='item.realRate'>
                *
                {{ currentRmNum }}
              </span>
            </div>

            <div class='edit-reason'>
              <select v-model="item.dscResaon"
                      class="options"
                      style="width: 98%">
                <option v-for="(item2,index2) in reasonList"
                        :value="item2.code"
                        :key="index2">{{ item2.descript }}({{ item2.disc1 * 100 }}%)
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class='edit-price-footer'>
          <div class='edit-price-btn price-cancel-btn'
               @click='syncPrice'>{{ $t('book_sync') }}
          </div>
          <div class='edit-price-btn'
               @click='confirmEditPrice'>{{ $t('determine') }}
          </div>
        </div>
      </div>
    </div>

    <div class='edit-ratecode-modal'
         v-if='showChangeRateModal'>
      <div class='edit-ratecode-modal-container'>
        <div class='edit-ratecode-title'>
          {{ $t('book_ratecode') }} <span v-if="currentItem.roomName">（{{ currentItem.roomName }}）</span>
          <i class='iconfont icon-cuowu'
             @click='closeRateChangeModal'></i>
        </div>

        <div class='search-rate-wrap'>
          {{ $t('search') }}：<input class="spe-search" v-model="searchRate" type="text">
        </div>

        <div class="ratecode-modal-body">
          <div class="left-arr">
            <div class="left-item"
                 :class="index == currentRateTypeIndex ? 'active' : ''"
                 v-for="(item,index) in ratecodeCategroyArr"
                 :key="'ratecodeCategroyArr' + index"
                 @click="getRateCodeArr(item.code, index)">
              {{ item.descript || '' }}
            </div>
          </div>
          <div class="right-arr" v-if="ratecodeArr.length">
            <div class="right-item"
                 v-show="!searchRate || ((item.code.indexOf(searchRate) > -1) || (item.name.indexOf(searchRate) > -1))"
                 :class="item.code == currentRateType ? 'active' : ''"
                 v-for="(item,index) in ratecodeArr"
                 @click="setCurrentRateType(item)"
                 :key="'ratecodeArr' + index">
              {{ item.code }} -- {{ item.name }}
            </div>
          </div>
          <div class="right-arr" v-else>
            <div class="right-item no-data">
              {{ $t('book_no_ratecode') }}
            </div>
          </div>
        </div>
        <div class='edit-ratecode-footer'>
          <div class='edit-ratecode-btn ratecode-cancel-btn'
               @click='closeRateChangeModal'>{{ $t('cancel') }}
          </div>
          <div class='edit-ratecode-btn'
               @click='changeRateCode2'>{{ $t('determine') }}
          </div>
        </div>
      </div>
    </div>


    <div class='edit-ratecode-modal'
         v-if='showSaleSelect'>
      <div class='edit-ratecode-modal-container'>
        <div class='edit-ratecode-title'>
          {{ $t('book_salesman') }}
          <i class='iconfont icon-cuowu'
             @click='closeSaleSelect'></i>
        </div>

        <div class='search-rate-wrap'>
          {{ $t('search') }}：<input class="spe-search" v-model="searchSaleMan" type="text">
        </div>
        <div class="ratecode-modal-body">
          <div class="right-arr" style="width: 100%" v-if="saleManList.length">
            <div class="right-item spe"
                 v-show="!searchSaleMan || ((item.code.indexOf(searchSaleMan) > -1) || (item.name.indexOf(searchSaleMan) > -1))"
                 :class="item.code == choosedSaleManCode ? 'active' : ''"
                 v-for="(item,index) in saleManList"
                 @click="setCurrentSaleMan(item)"
                 :key="'saleMan' + index">
              {{ item.code }} -- {{ item.name }}
            </div>
          </div>
          <div class="right-arr" style="width: 100%" v-else>
            <div class="right-item spe no-data">
              {{ $t('nothing') }}
            </div>
          </div>
        </div>
        <div class='edit-ratecode-footer'>
          <div class='edit-ratecode-btn ratecode-cancel-btn'
               @click='closeSaleSelect'>{{ $t('cancel') }}
          </div>
          <div class='edit-ratecode-btn'
               @click='changeSale'>{{ $t('determine') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Toast, MessageBox
} from 'mint-ui';
import moment from 'moment';
import popSearch from '../../common/popSearch';
import Datepicker from '../../common/Datepicker';
import gpicker from '../../common/gpicker';
import multiSelect from '../../common/multiSelect';
import inputNumber from '../../common/inputNumber';
import bookTab from './book-comp/bookTab';
import bookFooter from './book-comp/bookFooter'
import {mapState, mapGetters} from 'vuex';
import _ from 'underscore'
import json from '../../../conf/datePick.js';
import axios from 'axios';

export default {
  data() {
    return {
      popupVisible: false,
      /*日历信息*/
      pageIndex: 1, //tab切换页面
      start: moment().format('YYYY-MM-DD'),
      end: moment().add(6, 'M').format('YYYY-MM-DD'),
      range: [
        this.$route.query.date || moment().format('YYYY-MM-DD'),
        this.$route.query.enddate || moment().add(1, 'd').format('YYYY-MM-DD')
      ],
      bookInfo: {
        //预定信息
        cardNo: '', //	卡号（可空，类型为会员时填写）
        idCode: '', //	证件类型（可空）
        idNo: '', //	证件号（可空）
        mobile: '', //	手机，散客会员时填写，协议公司可空
        remark: '', //备注（可空）
        rsvMan: '', //	预订人不可空
        salesman: '', //	销售员，可空
        rmno: '', //房号 可空

        // TODO 这些这次要改成数组形式
        rmtype: '', //	房型不可空
        ratecode: '', //	价格代码（非空）
        //

        payCode: '', //付款码
        rsvType: '',
        cmscode: '',
        market: '',
        src: '',
        channel: '',
        rsvCompanyId: '',
        token: '',
        rateSecret: '', //房价保密
        coMsg: '', //结账提示
        amenities: '', //客房布置
        specials: '', //特殊要求
        creditMan: '', //手工编号
        otaRsvNo: '', //OTA预订号
        vip: '', //Vip
        status: '', // 多房型入住 status: in
      },

      moreRoom: false, // 用户判断版，是否展示多房型效果
      bookingRsvSrcDto: [{
        'arr': this.$route.query.date || moment().format('YYYY-MM-DD'), //入住时间（非空）
        'dep': this.$route.query.enddate || moment().add(1, 'd').format('YYYY-MM-DD'), //离店时间（非空）
        'rmnum': 1, //房间数（不可空》=1
        'ratecode': '', //	价格代码（非空）
        'rmtype': '', //	房型不可空
        'packages': '', // 包价
        firstDayMoney: '', // 首日房价
        everyDayRate: {} // 每日房价
      }],
      currentIndex: 0,
      showRoomItem: true,
      defaultRateCode: '', // 默认房价码

      rateSecret: false,
      isBook: true,
      rmData: {},
      rateCodeData: null,
      more: false,
      isReserve: true, //是否步入预订
      title: '预订',
      memberInfo: {}, //会员信息
      everyDayRate: {}, //每日房价
      sfzR: null,

      // 多房型预定
      isMultipleBook: false,


      // 优惠类型
      reasonList: [],
      currentItem: {}, // 当前编辑的房型节点
      showEditPriceModal: false,
      currentRmNum: 0,
      currentRsvRates: [], // 当前编辑的价格列表
      rsvRates: [
        //   {
        //   realRate: 100,
        //   dscResaon: '董事长优惠',
        //   date: '2020-02-13'
        // }
      ],
      clearRsvRates: true, // 是否清空当前节点的自定义房价
      currentLi: {},
      rateChange: false,


      // 锦江刷身份证
      jingJiangToken: '',
      chainNo: '',
      Key: '',
      isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
      secretKey: '',

      isMultipleBookIn: false, // 多房型入住

      currentRateTypeIndex: 0,
      currentRateType: '',
      showChangeRateModal: false,
      ratecodeCategroyArr: [], // 房价码类别
      ratecodeArr: [], // 房价码
      choosedRateCodeItem: {},

      searchRate: '', // 房价码搜索
      showSaleSelect: false,
      selectedSale: '',
      saleManList: [],
      searchSaleMan: '',
      choosedSaleMan: {},
      choosedSaleManCode: '',
    }
  },
  mounted() {
    let query = this.$route.query || {}
    this.bookInfo.rmtype = query.rmtype;
    this.bookInfo.rmno = query.rmno;
    this.rateChange = localStorage.getItem('rateChange') == 'yes'

    this.isBook = query.rmno == null;

    if (!this.isBook) {
      this.bookingRsvSrcDto[0].rmtype = query.rmtype
    }

    this.isReserve = query.isReserve == null || query.isReserve;
    // 预定 入住
    this.title = this.isReserve ? this.$t('book_reserveBook') : this.$t('book_walkBook');

    let isMultipleBook = query.isMultipleBook == 'yes'
    if (isMultipleBook) {
      this.isBook = false
      this.isMultipleBook = true
    }
    let isMultipleBookIn = query.isMultipleBookIn == 'yes'
    if (isMultipleBookIn) {
      this.title = this.$t('book_walkBook');
      this.bookInfo.status = 'in'
      this.isMultipleBookIn = true
    }

    if(this.$bookNew){
      this.getOrderInitNew(); //获取房型
    } else{
      this.getOrderInit(); //获取房型
    }
    this.getReasonList()
    this.getRateCodeType()
  },
  methods: {
    openSaleSelect() {
      this.showSaleSelect = true
    },
    closeSaleSelect() {
      this.showSaleSelect = false
    },
    setCurrentSaleMan(item) {
      this.choosedSaleMan = item || {}
      this.choosedSaleManCode = item.code || ''
    },
    changeSale() {
      this.showSaleSelect = false
    },
    getCurrentRateText() {
      var temp = this.choosedRateCodeItem || {}
      if (temp.code) {
        return temp.code + ' -- ' + temp.name
      } else {
        return ''
      }
    },
    openChangeRateModal() {
      this.currentRateTypeIndex = 0
      this.getRateCodeArr('', 0)
      this.searchRate = ''
      this.showChangeRateModal = true
    },
    closeRateChangeModal() {
      this.showChangeRateModal = false
    },
    setCurrentRateType(item) {
      this.choosedRateCodeItem = item || {}
      this.currentRateType = item.code || ''
    },
    getRateCodeType() {
      this.$http.post('/mobilepmsapi/reception/selectRatecodeCategroy', {}).then(res => {
        if (res.data.result == 0) {
          var temp = res.data || {}
          let arr = temp.retVal || []
          arr.unshift({
            code: '',
            descript: '全部'
          })
          this.ratecodeCategroyArr = arr
          this.getRateCodeArr('', 0)
        } else {
        }
      });
    },
    getRateCodeArr(code, index) {
      this.searchRate = ''
      this.currentRateType = ''
      this.currentRateTypeIndex = index
      this.$http.post('/mobilepmsapi/reception/getRatecodeCategroy ', {
        code: code
      }).then(res => {
        if (res.data.result == 0) {
          var temp = res.data || {}
          this.ratecodeArr = temp.retVal || []
        } else {
        }
      });
    },
    // 锦江读身份证
    jingjiangShuaka() {
      const that = this
      let obj = {
        'Key': this.Key,
        'Token': this.jingJiangToken,
        'Category': '1', // 1身份证 2身份证解码信息
        'EventName': 'Read',
        'CardType': 'IDCard',
        'isJingJiangLocal': true
      }
      this.wakeUpJingJiangApp('readIdCard')
      this.$http.post('/CardService/RequestForWrite', obj).then(res => {
        if (res.data.result == 0) {
          this.msg2(this.$t('jj_id_card_read_success'))
          var retVal = res.data.retVal || {}
          let so = JSON.parse(retVal.ResponseParameters || "{}") || {}
          that.bookInfo.rsvMan = so.name;
          that.bookInfo.idCode = '01';
          that.bookInfo.idNo = so.idnum;
          that.bookInfo.address = so.address;
          that.bookInfo.sex = so.sex;
          that.bookInfo.birthday = so.birthDate;
          that.bookInfo.national = so.nation;
        } else {
          MessageBox.alert(res.data.msg)
        }
      });
    },

    getJingJiangToken() {
      let objStr = localStorage.getItem('JingJiangSetting') || '{}'
      let obj = JSON.parse(objStr)
      this.chainNo = obj.HotelId || ''
      this.Key = obj.Key || ''
      obj.isJingJiangLocal = true
      this.$http.post('/CardService/Authorize', obj).then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal || {}
          this.jingJiangToken = retVal.Token || '';
          this.jingjiangShuaka()
        } else {
          this.msg2(this.$t('jj_token_error'));
        }
      });
    },

    openEditPriceModal() {
      let currentItem = this.bookingRsvSrcDto[this.currentIndex] || {}

      this.currentItem = currentItem
      if (!currentItem.rmtype) {
        this.msg(this.$t('book_select_type'))
        return
      }
      this.showEditPriceModal = true
      this.currentRmNum = currentItem.rmnum
      let currentRsvRates = []

      // 如果已经有自定义的房价，就用自定义的房价列表来渲染
      if (currentItem.rsvRates && currentItem.rsvRates.length > 0) {
        currentRsvRates = JSON.parse(JSON.stringify(currentItem.rsvRates || []))
      } else {
        let everyDayRate = currentItem.everyDayRate || {}
        currentRsvRates = JSON.parse(JSON.stringify(everyDayRate.list || []))

        currentRsvRates.map((item, index) => {
          item.realRate = '' // item.privce
        })
      }
      this.currentRsvRates = currentRsvRates

      this.$forceUpdate()
    },

    setCurrentLi(index) {
      this.currentLi = index
    },

    dateX(value) {
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
    },

    syncPrice() {
      let currentRsvRates = this.currentRsvRates || []
      let temp2 = currentRsvRates[this.currentLi]
      let tempReason = temp2.dscResaon
      let tempPrice = temp2.realRate
      currentRsvRates.map((item, index) => {
        item.dscResaon = tempReason
        item.realRate = tempPrice
      })
      this.currentRsvRates = currentRsvRates
      this.$forceUpdate()
    },

    closeEditPrice() {
      let currentItem = this.bookingRsvSrcDto[this.currentIndex] || {}

      this.currentRsvRates = []
      this.$forceUpdate()
      this.showEditPriceModal = false
    },
    confirmEditPrice() {
      let currentItem = this.bookingRsvSrcDto[this.currentIndex] || {}
      let temp = JSON.parse(JSON.stringify(this.currentRsvRates || []))
      var flag = true
      var msg = ''
      temp.map((item, index) => {
        item.date = this.dateX(item.d)
        var dscResaon = item.dscResaon
        var reason = this.getReason(dscResaon)
        var disc1 = reason.disc1
        var minPrice = item.privce * (1 - disc1)

        if (item.realRate !== '') {
          if (Number(item.realRate) < minPrice) {
            msg = item.date + ' \n ' + reason.descript + '的多可以优惠' + (disc1 * 100) + '%,最低优惠价格为' + parseFloat(minPrice).toFixed(2) + ', 请调整房价或优惠理由'
            flag = false
          } else {
            item.realRate = Number(item.realRate)
          }
        }
      })

      if (flag) {
        currentItem.rsvRates = temp || []
        this.currentRsvRates = []
        if (currentItem.rsvRates && currentItem.rsvRates[0] && currentItem.rsvRates[0].realRate !== '') {
          currentItem.firstDayMoney = currentItem.rsvRates[0].realRate
        }
        this.showEditPriceModal = false
        this.$refs.bookFooter.$forceUpdate()
      } else {
        this.msg(msg)
      }
    },

    getReason(reason) {
      var reasonList = this.reasonList || []
      var temp = {}
      reasonList.map((item) => {
        if (reason == item.code) {
          temp = item
        }
      })
      return temp
    },

    dateChange(date) {
      if (this.isMultipleBook) {
        return
      }
      // TODO 根据日期改变，下面的酒店也要改变
      let temp = date || []
      let beginDate = temp[0] || ''
      let endDate = temp[1] || ''

      this.$http.post('/mobilepmsapi/reception/getRmTypeOcc', {
        arr: beginDate,
        dep: endDate,
        rmnum: 1, //this.bookInfo.rmnum,
      }).then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal || {};
          this.rmData = retVal;
          if (this.isBook) {
            let rmType = null
            if (this.bookingRsvSrcDto[this.currentIndex].rmtype) {
              rmType = this.bookingRsvSrcDto[this.currentIndex].rmtype
            }
            this.$refs.rmtype.setData(this.rmData, rmType, this.disRmType); // 默认房型为空
          } else {
            this.bookingRsvSrcDto[this.currentIndex].rmtype = this.bookInfo.rmtype
          }
        } else {
          this.msg2(res.data.msg);
        }
      });
    },

    // 格式化多房型的数据
    formatMultipleRoomData() {
      let arr = this.multipleBookRoomList || []
      let tempObj = {}
      arr.map((item, index) => {
        tempObj[item.rmtype] = []
      })
      arr.map((item, index) => {
        let tempItem = {
          rmno: item.rmno,
          rmtype: item.rmtype
        }
        if (item.rmtype) {
          tempObj[item.rmtype].push(tempItem)
        }
      })

      let finalArr = []
      for (let key in tempObj) {
        let arr = tempObj[key] || []
        let obj = {
          'arr': this.$route.query.date || moment().format('YYYY-MM-DD'), //入住时间（非空）
          'dep': this.$route.query.enddate || moment().add(1, 'd').format('YYYY-MM-DD'), //离店时间（非空）
          'rmnum': arr.length,
          'ratecode': this.defaultRateCode, //	价格代码（非空）
          'rmtype': key,
          'rmno': _.pluck(arr, 'rmno').join(','),
          'packages': '', // 包价
          'firstDayMoney': '', // 首日房价
          'everyDayRate': {} // 每日房价
        }
        finalArr.push(obj)
      }
      this.bookingRsvSrcDto = finalArr || []
      this.$store.commit('clearMultipleBookRoomList') // 清空多选房型的数据
      console.log('对象', finalArr)
      this.changeAllEveryDayRate()
      console.log('对象2', finalArr)
    },
    // 需要设置对应的值，很麻烦
    selectRoomIndex(item, index) {
      const self = this
      this.currentIndex = index
      this.showRoomItem = false

      // 这里由于组件的缓存问题，需要 setTimeout来刷新，暂时实现比较丑陋
      setTimeout(() => {
        this.showRoomItem = true

        setTimeout(() => {
          self.setRoomValue(item)
        }, 10)
      }, 10)
    },

    setChooseRateItem(code) {
      this.rateCodeData.map((item, index) => {
        if (code == item.code) {
          this.choosedRateCodeItem = item
          this.currentRateTypeIndex = 0
          this.currentRateType = item.code || ''
        }
      })
    },

    setRoomValue(item) {
      let range = []
      range[0] = item.arr || this.$route.query.date || moment().format('YYYY-MM-DD')
      range[1] = item.dep || this.$route.query.enddate || moment().add(1, 'd').format('YYYY-MM-DD')
      this.$refs.rangePicker.setValue(range, 'yes')
      this.dateChange(range) // 日期改变，查询的房间数量也要改变
      this.bookInfo.rmnum = item.rmnum

      this.clearRsvRates = false

      // 这里不能用 setDefault,会触发 onChange事件，很绕
      if (this.$refs.rmtype) {
        this.$refs.rmtype.setDefault(item.rmtype || null); // 默认房型为空
      }
      this.$refs.ratecode.setData(this.rateCodeData, item.ratecode || this.defaultRateCode, this.disCodeName);
      this.setChooseRateItem(item.ratecode || this.defaultRateCode)

      if (!item.packages) {
        this.changeRateCode('no', 'yes')
      }

      this.$refs.pkage.setDefault(item.packages || null); // 设置默认包价
    },

    addRoomItem() {
      // 取前一个的数据，清空房数和房类型
      let length = this.bookingRsvSrcDto.length
      let oldItem = this.bookingRsvSrcDto[length - 1]
      let target = JSON.parse(JSON.stringify(oldItem))
      target.rmnum = 1
      target.rmtype = ''
      target.firstDayMoney = ''
      target.everyDayRate = {}
      target.rsvRates = []

      this.bookingRsvSrcDto.push(target)
      this.selectRoomIndex(target, this.bookingRsvSrcDto.length - 1)
    },

    removeRoomItem() {
      if (this.bookingRsvSrcDto.length > 1) {
        this.confirm2(
          this.$t('MessageBox_AccountIn_remove_item'), action => {
            this.bookingRsvSrcDto.splice(this.currentIndex, 1);
            // 删除之后显示哪个，如果是第一个删除，就显示后面的那个，不然就显示前一个节点
            if (this.currentIndex != 0) {
              this.currentIndex -= 1
            }
            this.selectRoomIndex(this.bookingRsvSrcDto[this.currentIndex], this.currentIndex)
          })
      } else {
        Toast(this.$t('Toast_del_last'));
      }
    },

    changeRmType(val) {
      let roomName = this.getRoomName(val)
      this.bookingRsvSrcDto[this.currentIndex].rmtype = val
      this.bookingRsvSrcDto[this.currentIndex].roomName = roomName
      this.getEverydayRate()
    },

    getRoomName(code) {
      let name = ''
      let rmData = this.rmData || []
      if (rmData.length > 0) {
        rmData.map((item) => {
          if (item.code == code) {
            name = item.name
          }
        })
      }
      return name
    },

    changePackages(val) {
      console.log('changePackages', val)
      this.bookingRsvSrcDto[this.currentIndex].packages = val
    },

    getReasonList() {
      this.$http
        .post('/mobilepmsapi/reception/listCodeReason')
        .then(res => {
          if (res.data.result == 0) {
            this.reasonList = res.data.retVal.resultInfo || []
          } else {
            this.msg2(res.data.msg);
          }
        });
    },

    /*获取每日房价*/
    getEverydayRate(index) {
      let tempIndex = ''
      if (index != undefined) { // 这里强烈注意 index 为0的情况
        tempIndex = index
      } else {
        tempIndex = this.currentIndex
      }
      let currentItem = this.bookingRsvSrcDto[tempIndex] || {}
      let arr = currentItem.arr
      let dep = currentItem.dep
      let rmtype = currentItem.rmtype
      let ratecode = currentItem.ratecode
      if (arr && dep && ratecode && rmtype) {
        this.$http
          .post('/mobilepmsapi/reception/rateQueryEveryDay', {
            start: arr,
            end: dep,
            ratecode,
            rmnum: 1, //this.bookInfo.rmnum,
            rmtype
          })
          .then(res => {
            if (res.data.result == 0) {
              let everyDayRate = res.data.retVal || {};
              if (currentItem.rsvRates && currentItem.rsvRates[0] && currentItem.rsvRates[0].realRate != '') {
                currentItem.firstDayMoney = currentItem.rsvRates[0].realRate
              } else {
                currentItem.firstDayMoney = everyDayRate.firstDayMoney
              }
              currentItem.everyDayRate = everyDayRate

              if (this.clearRsvRates) {
                if (currentItem.rsvRates && currentItem.rsvRates.length > 0) {
                  this.msg2(this.$t('book_reset_price_notice'))
                }
                currentItem.rsvRates = []
                currentItem.firstDayMoney = everyDayRate.firstDayMoney
              }

              var list = everyDayRate.list || []
              var firstItem = list[0] || {}
              this.setSaleInfo(firstItem, currentItem)
            } else {
              currentItem.firstDayMoney = ''
              currentItem.everyDayRate = {}
              this.msg2(res.data.msg);
              if (this.clearRsvRates) {
                currentItem.rsvRates = []
              }
            }

            this.clearRsvRates = true
          });
      }
    },

    // 修改房型的时候，也要同步去修改 市场，来源，佣金，包价
    // cmsCode: "TEST"
    // count: 1
    // d: "2023-10-27 00:00:00"
    // market: "WAK"
    // packages: "BF4,BJMXZ"
    // privce: 1
    // src: "WIK"
    setSaleInfo(item, currentItem){
      if (item.market) {
        this.$refs.market.setDefault(item.market);
      }
      if (item.src) {
        this.$refs.src.setDefault(item.src);
      }
      if (item.cmsCode) {
        this.$refs.cms_code.setDefault(item.cmsCode);
      }
      if(item.packages){
        this.$refs.pkage.setDefault(item.packages);
        currentItem.packages = item.packages
      }
    },

    changeAllEveryDayRate() {
      if (this.bookingRsvSrcDto && this.bookingRsvSrcDto.length > 0) {
        this.bookingRsvSrcDto.map((item, index) => {
          this.getEverydayRate(index)
        })
      }
    },

    // 预定初始化，新版拆分接口
    getOrderInitNew() {
      var self = this
      axios.all([this.bookInitForRmtype(), this.bookInitForReteCode(),this.bookInitForDefault(), this.bookInitForLast()])
      .then(axios.spread((a, b,c,d) => {
        var finalObj = d

        finalObj.sfzR = a.sfzR
        finalObj.rmtype = a.rmtype
        finalObj.idCode = a.idCode
        finalObj.token = a.token

        finalObj.packages = b.packages
        finalObj.rateCodeList = b.rateCodeList

        finalObj.defaultChannel = c.defaultChannel
        finalObj.defaultMarket = c.defaultMarket
        finalObj.defaultPayCode = c.defaultPayCode
        finalObj.defaultRateCode = c.defaultRateCode
        finalObj.defaultRsvType = c.defaultRsvType
        finalObj.defaultSrc = c.defaultSrc

        console.log('最后拼接完成的对象',finalObj)
        self.getOrderInitNext(finalObj)
      }));
    },

    bookInitForRmtype() {
      return this.$http.post('/mobilepmsapi/reception/bookInitForRmtype', {
        arr: this.range[0],
        dep: this.range[1],
        rmnum: 1
      }).then(res => {
        if (res.data.result == 0) {
          var data = res.data || {}
          return data.retVal || {}
        } else {
          this.msg(res.data.msg);
          return {}
        }
      });
    },
    bookInitForReteCode() {
      return this.$http.post('/mobilepmsapi/reception/bookInitForReteCode', {
      }).then(res => {
        if (res.data.result == 0) {
          var data = res.data || {}
          return data.retVal || {}
        } else {
          this.msg(res.data.msg);
          return {}
        }
      });
    },
    bookInitForDefault() {
      return this.$http.post('/mobilepmsapi/reception/bookInitForDefault', {
      }).then(res => {
        if (res.data.result == 0) {
          var data = res.data || {}
          return data.retVal || {}
        } else {
          this.msg(res.data.msg);
          return {}
        }
      });
    },
    bookInitForLast() {
      return this.$http.post('/mobilepmsapi/reception/bookInitForLast', {
      }).then(res => {
        if (res.data.result == 0) {
          var data = res.data || {}
          return data.retVal || {}
        } else {
          this.msg(res.data.msg);
          return {}
        }
      });
    },


    /*预定初始化信息 老版本*/
    getOrderInit() {
      this.$http.post('/mobilepmsapi/reception/bookInit', {
        arr: this.range[0],
        dep: this.range[1],
        rmnum: 1
      }).then(res => {
        if (res.data.result == 0) {
          console.log('原始的对象', res.data.retVal)
          this.getOrderInitNext(res.data.retVal || {})
        } else {
          this.msg(res.data.msg);
        }
      });
    },

    getOrderInitNext(retVal){
        this.moreRoom = retVal.moreRoom || false
        // 此处如果是 皓谷，目前不支持多房型预定
        if (!this.$isMihotel) {
          this.moreRoom = false
        }
        this.sfzR = retVal.sfzR;
        this.bookInfo.token = retVal.token;
        let disCodeName = this.disCodeName

        this.$refs.idCode.setData(retVal.idCode, '01', disCodeName);
        this.rmData = retVal.rmtype;
        if (this.isBook) {
          this.$refs.rmtype.setData(this.rmData, null, this.disRmType); // 默认房型为空
        } else {
          this.bookingRsvSrcDto[this.currentIndex].rmtype = this.bookInfo.rmtype
        }
        this.rateCodeData = retVal.rateCodeList || [];
        this.$refs.cms_code.setData(retVal.cms_code, null, disCodeName);
        this.$refs.ratecode.setData(this.rateCodeData, retVal.defaultRateCode, disCodeName);

        // 默认房价码如果已经不启用了，就使用可用的房价码中的第一个
        var rateCodeData = this.rateCodeData || []
        var flag = false
        rateCodeData.map((item, index) => {
          if (item.code == retVal.defaultRateCode) {
            flag = true
          }
        })
        if (flag) {
          this.defaultRateCode = retVal.defaultRateCode // 设置房价码默认值
        } else {
          var firstRateItem = rateCodeData[0] || {}
          this.defaultRateCode = firstRateItem.code || ''
        }

        this.setChooseRateItem(this.defaultRateCode)

        this.$refs.rsvType.setData(retVal.rsvType, retVal.defaultRsvType, disCodeName);
        this.$refs.market.setData(retVal.market, retVal.defaultMarket, disCodeName);
        this.$refs.src.setData(retVal.src, retVal.defaultSrc, disCodeName);
        this.$refs.channel.setData(retVal.channel, retVal.defaultChannel, disCodeName);
        // this.$refs.salesman.setData(retVal.saleMan, null, disCodeName);
        this.saleManList = retVal.saleMan || ''
        this.$refs.pkage.setData(retVal.packages, null);
        this.$refs.payCode.setData(retVal.payCodes, retVal.defaultPayCode, disCodeName);

        if (this.isMultipleBook) {
          this.formatMultipleRoomData()
          this.changeRateCode();
        } else {
          this.changeRateCode();
          this.getEverydayRate();
        }
        // 这种情况是从会员详情直接调过来预定
        this.setOtherInfo()
    },

    // 这种情况是从会员详情直接调过来预定
    setOtherInfo() {
      if (this.$route.query.pageIndex != null) {
        this.pageIndex = this.$route.query.pageIndex;
        var v = JSON.parse(this.$route.query.mem);
        this.bookInfo.rsvMan = v.name;
        this.$refs.inputmem.setInValue(v.cardNo);
        this.bookInfo.cardNo = v.cardNo;
        this.bookInfo.mobile = v.mobile;
        if (v.idNo) {
          this.bookInfo.idNo = v.idNo;
        }
        if (v.rateCode) {
          this.$refs.ratecode.setDefault(v.rateCode);
          this.setChooseRateItem(v.rateCode)
        }
        if (v.idType) {
          this.$refs.idCode.setDefault(v.idType);
        }
      }
    },

    rmnumChange() {
      this.bookInfo.rmnum = parseInt(this.$refs.rmnum.getValue());
      this.$refs.rmtype.setData(
        this.rmData,
        this.$refs.rmtype.getValue(),
        this.disRmType
      );
    },
    disCodeName(v) {
      return v.code + ' -- ' + v.name;
    },
    disRmType(v) {
      let text = v.code + ' -- ' + v.name;
      // "（房量不足）"  " -- 剩"   "间"
      text +=
        v.left < this.bookInfo.rmnum ?
          this.$t('book_disRmType_des') :
          this.$t('book_disRmType_left') +
          v.left +
          this.$t('book_disRmType_unit');
      return text;
    },

    changeRateCode2() {
      var temp = this.choosedRateCodeItem || {}
      var code = temp.code || ''
      if (code) {
        this.closeRateChangeModal()
        this.changeRateCode('no', 'no', 'yes')
      } else {
        this.msg('请选择房价码')
      }
    },
    changeRateCode(setMultiple, noChangeEveryDayRate, isNew) {
      if (isNew == 'yes') {
        this.closeRateChangeModal()
        var temp = this.choosedRateCodeItem || {}
        var code = temp.code || ''
        this.$refs.ratecode.setData(this.rateCodeData, code, this.disCodeName);
      } else {
        var code = this.$refs.ratecode.getValue();
      }
      if (code) {
        let currentItem = this.bookingRsvSrcDto[this.currentIndex] || {}
        currentItem.ratecode = code

        this.rateCodeData.map((item, index) => {
          if (item.code == code) {
            if (item.market) {
              this.$refs.market.setDefault(item.market);
            }
            if (item.src) {
              this.$refs.src.setDefault(item.src);
            }
            this.$refs.cms_code.setDefault(item.cms_code);
            this.$refs.pkage.setDefault(item.packages);
            if (setMultiple == 'yes') {
              this.bookingRsvSrcDto.map((item2, index) => {
                item2.packages = item.packages
              })
            } else {
              currentItem.packages = item.packages
            }
          }
        })
        if (noChangeEveryDayRate == 'yes') {
        } else {
          this.getEverydayRate();
        }
      }
    },

    sfzRe() {
      var A = plus.webview.getLaunchWebview();
      var that = this;
      window.sfzback = function (a) {
        //alert(a);
        var so = JSON.parse(a);
        if (so.error_code != 0) {
          //识别失败！请正面对准身份证，当照片清楚时再拍摄。
          that.msg(this.$t('msg_error_code'));
        } else {
          that.bookInfo.rsvMan = so.name;
          that.bookInfo.idCode = '01';
          that.bookInfo.idNo = so.id_number;
          that.bookInfo.address = so.address;
          that.bookInfo.sex = so.sex;
          that.bookInfo.birthday = so.birthday;
          that.bookInfo.national = so.people;
        }
      };
      A.evalJS('getSFZ(\'' + that.sfzR + '\')');
    },

    /*切换tab*/
    showPage(value) {
      if (this.pageIndex != value) {
        this.pageIndex = value;
        //清空searchText
        this.$refs.inputmem.clearData();
        this.$refs.inputa.clearData();
        this.$refs.inputc.clearData();
        this.$refs.inputs.clearData();
        //清空上一次在其他tab里选中的会员卡，协议公司和中介
        this.bookInfo.rsvCompanyId = '';
        this.bookInfo.cardNo = '';
      }
    },
    msg(msg) {
      Toast({
        message: msg,
        position: 'bottom',
        duration: 3000
      });
      return false;
    },
    onSelect(value) {
      // console.log(value);
      if (value.rateCode) {
        var code = value.rateCode;
        if (code.indexOf(',') >= 0) {
          code = code.split(',')[0];
        }
        this.$refs.ratecode.setDefault(code);
        this.setChooseRateItem(code)
        this.bookingRsvSrcDto.map((item, index) => {
          item.ratecode = code
        })
        this.changeRateCode('yes') // 选择会员卡时重置所有房型的 ratecode 和 packages
        this.changeAllEveryDayRate()
      }

      if (this.pageIndex == 2) {
        this.bookInfo.cardNo = value.cardNo;
        this.bookInfo.rsvMan = value.name;
        if (value.idNo != null && value.idNo != '') {
          this.bookInfo.idNo = value.idNo;
        }
        if (value.mobile) {
          this.bookInfo.mobile = value.mobile;
        }
        if (value.idType != null && value.idType != '') {
          this.$refs.idCode.setDefault(value.idType);
        }
      } else {
        this.bookInfo.rsvCompanyId = value.id;
        if (value.saleman != null && value.saleman != '') {
          // this.$refs.salesman.setDefault(value.saleman);
          // saleman: "003"
          // salemanDis: "张三"
          this.choosedSaleManCode = value.saleman // "003"
          this.choosedSaleMan = {
            code: value.saleman,
            name: value.salemanDis
          }
        }

        if (value.src != null && value.src != '') {
          this.$refs.src.setDefault(value.src);
        }
        if (value.market != null && value.market != '') {
          this.$refs.market.setDefault(value.market);
        }
        if (value.cms_code != null && value.cms_code != '') {
          this.$refs.cms_code.setDefault(value.cms_code);
        }
      }
      this.getEverydayRate();
    },

    //预定或者入住
    book() {
      if (this.pageIndex == 4) {
        if (_.isEmpty(this.bookInfo.rsvCompanyId)) {
          return this.msg(this.$t('msg_rsvCompanyId4'));
        }
      } else if (this.pageIndex == 3) {
        if (_.isEmpty(this.bookInfo.rsvCompanyId)) {
          return this.msg(this.$t('msg_rsvCompanyId3'));
        }
      } else if (this.pageIndex == 2) {
        if (_.isEmpty(this.bookInfo.cardNo)) {
          return this.msg(this.$t('msg_rsvCompanyId2'));
        }
      }
      this.bookInfo.rsvType = this.$refs.rsvType.getValue();
      this.bookInfo.src = this.$refs.src.getValue();
      this.bookInfo.market = this.$refs.market.getValue();
      this.bookInfo.channel = this.$refs.channel.getValue();
      // this.bookInfo.salesman = this.$refs.salesman.getValue();
      this.bookInfo.salesman = this.choosedSaleManCode || '';
      this.bookInfo.cmscode = this.$refs.cms_code.getValue();

      this.bookInfo.payCode = this.$refs.payCode.getValue();
      this.bookInfo.rateSecret = this.rateSecret ? 'T' : '';
      if (this.isBook) {
        this.bookInfo.rmtype = this.$refs.rmtype.getValue();
      }
      this.bookInfo.idCode = this.$refs.idCode.getValue();
      if (_.isEmpty(this.bookInfo.rsvMan)) {
        return this.msg(this.$t('msg_rsvMan'));
      }

      // 循环校验一波
      if (this.bookingRsvSrcDto.length > 0) {
        let flag = true
        this.bookingRsvSrcDto.map((item, index) => {
          if (_.isEmpty(item.rmtype)) {
            flag = this.msg(this.$t('msg_rmtype'));
          }
          if (!item.arr || !item.dep) {
            flag = this.msg(this.$t('msg_range'));
          }
        })

        if (!flag) {
          return false
        }

        // 主单包价跟每日房价里的包价进行对比，如果跟第一天的对不上，就全覆盖每日房价，如果一致，就不覆盖
        this.bookingRsvSrcDto.map((item, index) => {
          var everyDayRate = item.everyDayRate || {}
          var list = everyDayRate.list || []
          var firstItem = list[0] || {}
          if(item.packages != firstItem.packages){
            list.map((item2) => {
              item2.packages = item.packages
            })
          }
        })
      }


      var address = 'book';
      if (!this.isMultipleBook) {
        if (!this.isBook) {
          if (_.isEmpty(this.bookInfo.idCode)) {
            return this.msg(this.$t('msg_idCode'));
          }
          if (this.isReserve) {
            address = 'reserve';
          } else {
            address = 'walkIn';
          }
        }
      }

      this.bookInfo.type = this.pageIndex;
      this.bookInfo.bookingRsvSrcDto = this.bookingRsvSrcDto || [] // 多房型

      // TODO
      console.log('TODO 预定的详情', this.bookInfo.bookingRsvSrcDto)

      // return
      this.$http
        .post('/mobilepmsapi/reception/' + address, this.bookInfo)
        .then(res => {
          if (res.data.result == 0) {
            this.msg(this.title + this.$t('success'));
            this.bookSuccess(res.data.retVal)
          } else {
            this.msg(res.data.msg);
            // this.error2(res.data.msg);
          }
        });
    },

    bookSuccess(retVal) {
      if (this.isBook) {
        this.$router.push('/orderDetail?rsvNo=' + retVal.rsvNo + '&redirect=/book');
      } else {
        if (retVal.isRoomDetail) {
          this.$router.push('/fangTXQ?id=' + retVal.id);
        } else {
          this.$router.push('/orderDetail?rsvNo=' + retVal.rsvNo + '&redirect=/fangT');
        }
      }
    }
  },
  components: {
    popSearch,
    Datepicker,
    gpicker,
    inputNumber,
    multiSelect,
    bookTab,
    bookFooter
  },
  watch: {
    range: {
      handler(curVal, oldVal) {
        this.bookingRsvSrcDto[this.currentIndex].arr = curVal[0]
        this.bookingRsvSrcDto[this.currentIndex].dep = curVal[1]

        this.getEverydayRate();
      },
      deep: true
    }
  },
  computed: {
    isNormal() {
      return this.bookingRsvSrcDto.length == 1
    },
    showDeleteBtn() {
      return this.bookingRsvSrcDto.length > 1
    },
    showDeleteBtn2() {
      return this.bookingRsvSrcDto.length > 1 && this.isMultipleBook
    },
    ...mapState({
      multipleBookRoomList: state => state.multipleBook.multipleBookRoomList
    })
  },
  filters: {
    dateMD(value) {
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('MM/DD');
    },
    week(value) {
      return moment(value).day() == 0
        ? json.week[json.week.length - 1]
        : json.week[moment(value).day() - 1];
    },
  }
};
</script>

<style lang="less">
@import "book";
</style>



// WEBPACK FOOTER //
// book.vue?2baeca68